"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.highbury = exports.gnosis = exports.polygon = exports.bnbsmartchain = exports.optimism = exports.thorchain = exports.avalanche = exports.cosmos = exports.ethereum = exports.litecoin = exports.dogecoin = exports.bitcoincash = exports.bitcoin = void 0;
const adapter_json_1 = __importDefault(require("./bip122_000000000019d6689c085ae165831e93/adapter.json"));
exports.bitcoin = adapter_json_1.default;
const adapter_json_2 = __importDefault(require("./bip122_000000000000000000651ef99cb9fcbe/adapter.json"));
exports.bitcoincash = adapter_json_2.default;
const adapter_json_3 = __importDefault(require("./bip122_00000000001a91e3dace36e2be3bf030/adapter.json"));
exports.dogecoin = adapter_json_3.default;
const adapter_json_4 = __importDefault(require("./bip122_12a765e31ffd4059bada1e25190f6e98/adapter.json"));
exports.litecoin = adapter_json_4.default;
const adapter_json_5 = __importDefault(require("./eip155_1/adapter.json"));
exports.ethereum = adapter_json_5.default;
const adapter_json_6 = __importDefault(require("./eip155_43114/adapter.json"));
exports.avalanche = adapter_json_6.default;
const adapter_json_7 = __importDefault(require("./eip155_10/adapter.json"));
exports.optimism = adapter_json_7.default;
const adapter_json_8 = __importDefault(require("./eip155_56/adapter.json"));
exports.bnbsmartchain = adapter_json_8.default;
const adapter_json_9 = __importDefault(require("./eip155_137/adapter.json"));
exports.polygon = adapter_json_9.default;
const adapter_json_10 = __importDefault(require("./eip155_100/adapter.json"));
exports.gnosis = adapter_json_10.default;
const adapter_json_11 = __importDefault(require("./eip155_710/adapter.json"));
exports.highbury = adapter_json_11.default;
const adapter_json_12 = __importDefault(require("./cosmos_cosmoshub-4/adapter.json"));
exports.cosmos = adapter_json_12.default;
const adapter_json_13 = __importDefault(require("./cosmos_thorchain-mainnet-v1/adapter.json"));
exports.thorchain = adapter_json_13.default;
